import axios from 'axios';

const chatBaseURL = 'https://crm.oneplacesolar.com/chat';
const websocketBaseURL = 'wss://crm.oneplacesolar.com/chat';

const api = axios.create({
    baseURL: 'https://crm.oneplacesolar.com/api', // Replace with your backend URL
    withCredentials: true
});

// Add a request interceptor to attach token
api.interceptors.request.use(
    (config) => {
        const token = sessionStorage.getItem("token");
        if (token) {
            config.headers["Authorization"] = token;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response && (error.response.status === 401)) {
            sessionStorage.removeItem("token"); // Clear token
        }
        return Promise.reject(error);
    }
);
export default api;
export { chatBaseURL, websocketBaseURL };